import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const ImageZoomDialog = ({ open, onClose, imageUrl }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const transformRef = React.useRef(null);

  const handleZoomIn = () => {
    transformRef.current?.zoomIn();
  };

  const handleZoomOut = () => {
    transformRef.current?.zoomOut();
  };

  const handleClose = () => {
    transformRef.current?.resetTransform();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
    >
      <DialogContent sx={{ position: "relative", p: 0, bgcolor: "black" }}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 10,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            overflow: "hidden",
            position: "relative",
            touchAction: "none", // for better touch interaction
          }}
        >
          <TransformWrapper
            ref={transformRef}
            initialScale={1}
            minScale={0.5}
            maxScale={4}
            wheel={{ step: 0.2 }}
            doubleClick={{ disabled: true }}
          >
            <TransformComponent>
              <img
                src={imageUrl}
                alt="Zoom Preview"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  borderRadius: "8px",
                }}
              />
            </TransformComponent>
          </TransformWrapper>
        </Box>

        <Box
          sx={{
            position: "absolute",
            bottom: 10,
            right: 10,
            display: "flex",
            gap: 1,
            zIndex: 10,
          }}
        >
          <IconButton
            onClick={handleZoomOut}
            sx={{
              bgcolor: "white",
              "&:hover": {
                bgcolor: "black",
                "& svg": {
                  color: "white",
                },
              },
              "& svg": {
                color: "black",
                transition: "color 0.2s",
              },
            }}
          >
            <ZoomOutIcon />
          </IconButton>
          <IconButton
            onClick={handleZoomIn}
            sx={{
              bgcolor: "white",
              "&:hover": {
                bgcolor: "black",
                "& svg": {
                  color: "white",
                },
              },
              "& svg": {
                color: "black",
                transition: "color 0.2s",
              },
            }}
          >
            <ZoomInIcon />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImageZoomDialog;
